import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function CitySelector({ value, onChange }) {
  const { t } = useTranslation();
  const [cities, setCities] = useState([]);
  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await fetch("/geojson/simplified_cities.json");
        const data = await res.json();

        const sorted = data
          .filter((c) => c.nameFr || c.nameEn)
          .sort((a, b) =>
            (a.nameFr || a.nameEn).localeCompare(b.nameFr || b.nameEn)
          );

        setCities(sorted);

        const selected = sorted.find((city) => city.id === value);
        if (selected) {
          setSearch(selected.nameFr || selected.nameEn);
        }
      } catch (err) {
        console.error("Erreur chargement villes", err);
      }
    };

    fetchCities();
  }, [value]);

  const filtered = cities.filter((city) =>
    (city.nameFr || city.nameEn || "")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const clearSelection = () => {
    onChange(null);
    setSearch("");
    setShowDropdown(false);
  };

  const handleSelect = (city) => {
    onChange(city.id);
    setSearch(city.nameFr || city.nameEn);
    setShowDropdown(false);
  };

  return (
    <div className="form-control w-full max-w-xs relative text-primary">
      <label className="label">
        <span className="label-text font-semibold">{t("global.city")}</span>
      </label>

      <div className="relative">
        <input
          type="text"
          placeholder={t("global.selectCity")}
          className="input input-bordered w-full pr-10"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setShowDropdown(true);
          }}
          onFocus={() => setShowDropdown(true)}
          onBlur={() => setTimeout(() => setShowDropdown(false), 100)}
        />

        {search !== "" && (
          <button
            type="button"
            onClick={clearSelection}
            className="absolute right-3 top-1/2 -translate-y-1/2 z-20 text-gray-500 hover:text-red-500 text-xl leading-none"
            aria-label="Clear"
          >
            ×
          </button>
        )}

        {showDropdown && filtered.length > 0 && (
          <ul className="absolute z-10 bg-base-100 border rounded-lg mt-1 shadow w-full max-h-60 overflow-auto">
            {filtered.map((city) => (
              <li
                key={city.id}
                onMouseDown={() => handleSelect(city)}
                className="px-4 py-2 hover:bg-primary hover:text-white cursor-pointer"
              >
                {city.nameFr || city.nameEn}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
